import { RgCoreVersion } from '../../core-version.js';

const getRgVersions = () => ({
    core: RgCoreVersion
});

export { getRgVersions };
//# sourceMappingURL=get-versions.js.map
